(function () {
  if (window.BAPercentageStats) {
    window.BAPercentageStats.init(document);
    return;
  }

  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = null;

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function formatNumber(value, decimals) {
    return Number(value).toLocaleString(undefined, {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    });
  }

  function setValue(element, value, decimals) {
    element.textContent = formatNumber(value, decimals);
  }

  function animateCounter(element) {
    if (element.dataset.countComplete === 'true') {
      return;
    }

    var target = parseFloat(element.dataset.target || '0');
    var decimals = parseInt(element.dataset.decimals || '0', 10);
    var duration = parseInt(element.dataset.duration || '1400', 10);
    var disabled = element.dataset.countDisabled === 'true';

    element.dataset.countComplete = 'true';

    if (disabled || prefersReducedMotion || duration <= 0) {
      setValue(element, target, decimals);
      return;
    }

    var startTime = null;

    function tick(timestamp) {
      if (!startTime) {
        startTime = timestamp;
      }

      var progress = Math.min((timestamp - startTime) / duration, 1);
      var eased = easeOutCubic(progress);
      setValue(element, target * eased, decimals);

      if (progress < 1) {
        window.requestAnimationFrame(tick);
      } else {
        setValue(element, target, decimals);
      }
    }

    setValue(element, 0, decimals);
    window.requestAnimationFrame(tick);
  }

  function init(root) {
    var scope = root || document;
    var counters = scope.querySelectorAll('[data-percentage-count-up]:not([data-count-bound])');

    counters.forEach(function (counter) {
      counter.dataset.countBound = 'true';

      if (!('IntersectionObserver' in window)) {
        animateCounter(counter);
        return;
      }

      if (!observer) {
        observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              animateCounter(entry.target);
              observer.unobserve(entry.target);
            }
          });
        }, {
          threshold: 0.35
        });
      }

      observer.observe(counter);
    });
  }

  window.BAPercentageStats = {
    init: init
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
